import { render, staticRenderFns } from "./AddJoinRequestModal.vue?vue&type=template&id=edaf5cfa&scoped=true"
import script from "./AddJoinRequestModal.vue?vue&type=script&lang=js"
export * from "./AddJoinRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edaf5cfa",
  null
  
)

export default component.exports